import React, { useState } from 'react';
import MaterialIcon from '../shared/ui/icons/MaterialIcon';
import '../styles/verificationModal.css';

function VerificationModal({
  isOpen,
  onClose,
  onGiftCodeSubmit,
  onPromoCodeSubmit,
  onStripePayment,
  error,
  stripeLoading,
  originalPrice,
  discountedPrice,
}) {
  const [code, setCode] = useState('');
  const [mode, setMode] = useState(null);

  const handleGiftCodeSubmit = (e) => {
    e.preventDefault();
    onGiftCodeSubmit(code);
  };

  const handlePromoCodeSubmit = (e) => {
    e.preventDefault();
    onPromoCodeSubmit(code);
  };

  const handleStripeClick = () => {
    onStripePayment();
  };

  const handleClose = () => {
    setCode('');
    setMode(null);
    onClose();
  };

  if (!isOpen) return null;

  if (!mode) {
    return (
      <div className="modal-backdrop">
        <div className="modal modal-body card-padding">
          <div className="modal-header">
            <h2>Запазване на уебсайт</h2>
            <button className="close-button" onClick={handleClose}>&times;</button>
          </div>
          <div className="modal-body">
            <p>Изберете начин за завършване на създаването на вашия уебсайт.</p>
            <div className="payment-choice-container">
              <button
                className="payment-choice-btn payment-choice-stripe"
                onClick={handleStripeClick}
                disabled={stripeLoading}
              >
                <span className="payment-choice-icon"><MaterialIcon name="credit_card" size={20} /></span>
                <span className="payment-choice-text">
                  <strong>Плати сега - {originalPrice} €</strong>
                  <small>Платете с карта и създайте своя уебсайт моментално</small>
                </span>
                <span className="payment-choice-arrow">&rarr;</span>
              </button>
              <button
                className="payment-choice-btn payment-choice-promo"
                onClick={() => setMode('promo')}
              >
                <span className="payment-choice-icon"><MaterialIcon name="local_offer" size={20} /></span>
                <span className="payment-choice-text">
                  <strong>Въведи промо код</strong>
                </span>
                <span className="payment-choice-arrow">&rarr;</span>
              </button>
              <button
                className="payment-choice-btn payment-choice-code"
                onClick={() => setMode('code')}
              >
                <span className="payment-choice-icon"><MaterialIcon name="vpn_key" size={20} /></span>
                <span className="payment-choice-text">
                  <strong>Въведи код от агенция</strong>
                </span>
                <span className="payment-choice-arrow">&rarr;</span>
              </button>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-ghost btn-lg" onClick={handleClose}>
              Отказ
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (mode === 'promo') {
    return (
      <div className="modal-backdrop">
        <div className="modal modal-body card-padding">
          <div className="modal-header">
            <h2>Въведи промо код</h2>
            <button className="close-button" onClick={handleClose}>&times;</button>
          </div>
          <div className="modal-body">
            <p>
              Въведете промо кода си, за да получите намаление от {originalPrice} € на само {discountedPrice} €.
            </p>
            <form onSubmit={handlePromoCodeSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  placeholder="Въведете промо код"
                  className="input otp-input"
                  autoFocus
                />
              </div>
              {error && <div className="error-message">{error}</div>}
              <div className="modal-footer">
                <button type="button" className="btn btn-ghost btn-lg" onClick={() => { setCode(''); setMode(null); }}>
                  Назад
                </button>
                <button type="submit" className="submit-button">
                  Приложи
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-backdrop">
      <div className="modal modal-body card-padding">
        <div className="modal-header">
          <h2>Въведи код от агенция</h2>
          <button className="close-button" onClick={handleClose}>&times;</button>
        </div>
        <div className="modal-body">
          <p>Моля, въведете кода, който сте получили.</p>
          <form onSubmit={handleGiftCodeSubmit}>
            <div className="form-group">
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Въведи код от агенция"
                className="input otp-input"
                autoFocus
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            <div className="modal-footer">
              <button type="button" className="btn btn-ghost btn-lg" onClick={() => { setCode(''); setMode(null); }}>
                Назад
              </button>
              <button type="submit" className="submit-button">
                Потвърди и запази
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default VerificationModal;
